import {colorTheme} from '../../../ui-toolkit/mixin/colorTheme';
import styled from 'styled-components';
import {ColorThemeTables} from './ColorThemeTables';

export const ColorThemeShadow = styled(ColorThemeTables)`
    ${colorTheme({
        // ==== Shadows and Gradients ====
        // -------------------------------
        '--container-shadow-color-100     ': {
            dark: 'var(--shadow-dark-04)',
            light: 'var(--shadow-light-01)',
        },

        '--container-shadow-color-200     ': {
            dark: 'var(--shadow-dark-05)',
            light: 'var(--shadow-light-11)',
        },
        '--container-shadow-color-300     ': {
            dark: 'var(--shadow-dark-06)',
            light: 'var(--shadow-light-03)',
        },
        '--container-shadow-color-400     ': {
            dark: 'var(--shadow-dark-06)',
            light: 'var(--shadow-light-04)',
        },
        '--container-shadow-color-500      ': {dark: 'var(--shadow-dark-06)  ', light: 'var(--shadow-light-08)'},
        '--container-shadow-color-600     ': {
            dark: 'var(--shadow-dark-08)',
            light: 'var(--shadow-light-03)',
        },
        '--container-shadow-color-700      ': {dark: 'var(--shadow-dark-06)  ', light: 'var(--shadow-light-13)'},
        '--container-shadow-color-danger     ': {
            dark: 'var(--shadow-danger-01)',
            light: 'var(--shadow-danger-01)',
        },
    })};
`;
